export default __webpack_public_path__ + "static/logo6-adf6590263a478371c42add38725ffde.svg";